import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserManager } from 'oidc-client-ts';

const ButtonOIDC = ({ config, strategy, onSubmit, onError }) => {
  const userManager = new UserManager({
    authority: config.authority,
    client_id: config.clientId,
    redirect_uri: config.redirectUri,
    response_type: config.responseType || 'code',
    scope: config.scope || 'openid profile email',
    prompt: config.prompt || 'login',
    post_logout_redirect_uri: config.postLogoutRedirectUri
  });
  const [user, setUser] = useState(null);

  useEffect(() => {
    async function checkUser() {
      try {
        const user = await userManager.signinRedirectCallback();
        if (user) {
          const email = user.profile.email;
          await onSubmit({
            email,
            idToken: user.id_token
          });
        }

        setUser(user);
      } catch (error) {
        console.log(error.message);
      }
    }
    checkUser();
  }, [userManager]);

  const handleLogin = () => {
    userManager.signinRedirect();
  };

  const handleLogout = () => {
    userManager.signoutRedirect();
    setUser(null);
  };

  return (
    <>
      <Button
        variant='outlined'
        color='inherit'
        className='w-full border-muted'
        size='large'
        onClick={handleLogin}
        startIcon={<FontAwesomeIcon className='text-xl text-icon' icon={['fas', 'users-rays']} />}
      >
        <div className='flex items-center justify-start'>
          <div className='text-icon initial-case'>
            {strategy.label ?? `Sign in with ${strategy.service}`}{' '}
          </div>
        </div>
      </Button>
      {user && (
        <div>
          <p>Bienvenido, {user.profile.email}</p>
          <button onClick={handleLogout}>Cerrar sesión</button>
        </div>
      )}
    </>
  );
};

export default ButtonOIDC;
